export const paginationElementTypes = {
  CURRENT_PAGE: 'currentPage',
  PAGE: 'page',
  SEPARATOR: 'separator'
}